import { CheckCircle2 } from 'lucide-react';

type Props = {
  nome: string;
  corso: string;
  /** Ha detto si' alle comunicazioni: gli arrivera' la email di conferma. */
  conConsenso: boolean;
  onAltra: () => void;
};

/** Il foglio che sostituisce il modulo quando l'iscrizione e' arrivata. */
export function ConfermaIscrizione({ nome, corso, conConsenso, onAltra }: Props) {
  const saluto = nome.trim() ? `Grazie ${nome.trim()}` : 'Grazie';
  return (
    <div className="foglio-quadretti mt-8 rounded-2xl px-6 py-10 text-center shadow-2xl ring-1 ring-black/5">
      <CheckCircle2 className="mx-auto h-14 w-14 text-green-600" aria-hidden="true" />
      <h2 className="mt-3 text-2xl font-bold text-gray-900">Registrazione completata</h2>
      <p className="mt-3 text-lg leading-relaxed text-gray-700">
        {saluto}, abbiamo ricevuto la tua iscrizione{corso ? <> al corso <strong>{corso}</strong></> : ''}. Ti
        ricontatteremo a breve con tutti i dettagli.
      </p>
      {conConsenso && (
        <p className="mt-3 text-base leading-relaxed text-gray-600">
          Se non l'hai già fatto in passato, riceverai un'email per confermare che vuoi ricevere le nostre
          comunicazioni: controlla anche nella posta indesiderata.
        </p>
      )}
      <button
        type="button"
        onClick={onAltra}
        className="mt-6 rounded-full border-2 border-primary-600 bg-white px-6 py-2 text-base font-semibold text-primary-700 transition hover:bg-primary-50"
      >
        Iscrivi un'altra persona
      </button>
    </div>
  );
}
